import React, { useEffect, useState } from "react";
import popup from "../assets/popup.png";
const AutoPopup = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Jab component mount hoga, popup dikhega
    setShowPopup(true);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <img
              src={popup}
              alt="Popup"
              style={{ width: "100%", height: "auto" }}
            />
            <button className="close-btn" onClick={closePopup}>
              Close
            </button>
          </div>
        </div>
      )}

      <style jsx>{`
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }
        .popup-content {
          background: white;
          padding: 20px;
          border-radius: 10px;
          max-width: 500px;
          width: 90%;
          text-align: center;
          position: relative;
        }
        .close-btn {
          margin-top: 15px;
          padding: 10px 20px;
          background: #ff4d4f;
          color: white;
          border: none;
          border-radius: 5px;
          cursor: pointer;
        }
      `}</style>
    </>
  );
};

export default AutoPopup;
